import CreditReportNavLink from './CreditReportNavLink';
export default CreditReportNavLink;
